import MidwifeActivityController from '../overview/midwife.activity.controller'
import LocationActivityService from './location.activity.service'
import router from '#enna/common/router'

export default {
  async delete (midwifeId, pid) {
    const value = await LocationActivityService.delete(midwifeId, pid)
    return value
  },

  async load (midwifeId, pid, reloadId) {
    const response = await LocationActivityService.load(midwifeId, pid)
    const propDtoLocationActivity = response.data.dtoLocationActivity
    const regionList = response.data.regionList
    const midwifeName = response.data.midwifeName
    const activityName = response.data.activityName
    const activityType = response.data.activityType
    router.push({
      name: 'locationactivitydetail',
      params: {
        midwifeId: midwifeId,
        pid: pid,
        midwifeName: midwifeName,
        activityName: activityName,
        activityType: activityType,
        propDtoLocationActivity: propDtoLocationActivity,
        regionList: regionList
      },
      query: { reload: reloadId }
    })
  },

  async save (dtoLocationActivity) {
    await LocationActivityService.save(dtoLocationActivity)
    MidwifeActivityController.openMidwifeActivityOverview(dtoLocationActivity.midwifeId)
  },

  async generateActivity (data) {
    await LocationActivityService.generateActivity(data)
  }
}
